var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"toHome",on:{"click":_vm.toHome}}),_c('img',{staticClass:"full-image",attrs:{"src":require("../asset/img/2.jpg"),"alt":"产品"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }